import { useState } from "react";
import { doc, updateDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Icon from "./Icon";
import TimeSelector from "./TimeSelector";
import { SEGMENT_TYPES } from "../utils";

async function rebuildSearchText(tripId) {
  try {
    const segsSnap = await getDocs(collection(db, "trips", tripId, "segments"));
    const text = segsSnap.docs.map(d => {
      const s = d.data();
      return [s.title, s.address, s.detail, s.confirmation, s.phone].filter(Boolean).join(" ");
    }).join(" ").toLowerCase();
    await updateDoc(doc(db, "trips", tripId), { searchText: text });
  } catch (e) {
    console.warn("searchText update failed", e);
  }
}

export default function EditSegmentModal({ segment, tripId, onClose }) {
  const [title, setTitle] = useState(segment.title || "");
  const [address, setAddress] = useState(segment.address || "");
  const [detail, setDetail] = useState(segment.detail || "");
  const [date, setDate] = useState(segment.date || "");
  const [checkoutDate, setCheckoutDate] = useState(segment.checkoutDate || "");
  const [time, setTime] = useState(segment.time || "");
  const [confirmation, setConfirmation] = useState(segment.confirmation || "");
  const [phone, setPhone] = useState(segment.phone || "");
  const [link, setLink] = useState(segment.link || "");
  const [city, setCity] = useState(segment.city || "");
  const [saving, setSaving] = useState(false);

  const isHotel = segment.type === "hotel";
  const needsLocation = ["hotel", "restaurant", "activity"].includes(segment.type);
  const cfg = SEGMENT_TYPES[segment.type] || SEGMENT_TYPES.activity;

  const handleSave = async () => {
    setSaving(true);
    await updateDoc(doc(db, "trips", tripId, "segments", segment.id), {
      title, address, detail, date, time,
      checkoutDate: isHotel ? checkoutDate : "",
      confirmation, phone, link,
      city: needsLocation ? city : "",
    });
    await rebuildSearchText(tripId);
    setSaving(false);
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="modal">
        <div className="modal-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 28, height: 28, borderRadius: 6, background: cfg.bg, color: cfg.color, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Icon name={cfg.icon} size={13} />
            </div>
            <div className="modal-title">Edit {cfg.label}</div>
          </div>
          <button className="modal-close" onClick={onClose}><Icon name="close" size={14} /></button>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">{isHotel ? "Check-in" : "Date"}</label>
            <input className="form-input" type="date" value={date} onChange={(e) => setDate(e.target.value)} />
          </div>
          {isHotel ? (
            <div className="form-group">
              <label className="form-label">Check-out</label>
              <input className="form-input" type="date" value={checkoutDate} onChange={(e) => setCheckoutDate(e.target.value)} />
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Time</label>
              <TimeSelector value={time} onChange={setTime} segmentType={segment.type} />
            </div>
          )}
        </div>

        <div className="form-group">
          <label className="form-label">Name</label>
          <input className="form-input" value={title} onChange={(e) => setTitle(e.target.value)} />
        </div>

        {needsLocation && (
          <div className="form-group">
            <label className="form-label">City</label>
            <input className="form-input" placeholder="e.g. Paris, Tokyo" value={city} onChange={(e) => setCity(e.target.value)} />
          </div>
        )}

        {needsLocation && (
          <div className="form-group">
            <label className="form-label">Address</label>
            <input className="form-input" value={address} onChange={(e) => setAddress(e.target.value)} />
          </div>
        )}

        <div className="form-group">
          <label className="form-label">Details</label>
          <input
            className="form-input"
            placeholder={segment.type === "restaurant" ? "How was it? Notes..." : "Additional details"}
            value={detail}
            onChange={(e) => setDetail(e.target.value)}
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label className="form-label">Confirmation #</label>
            <input className="form-input" value={confirmation} onChange={(e) => setConfirmation(e.target.value)} />
          </div>
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input className="form-input" value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
        </div>

        <div className="form-group">
          <label className="form-label">Website</label>
          <input className="form-input" value={link} onChange={(e) => setLink(e.target.value)} />
        </div>

        <button className="submit-btn" onClick={handleSave} disabled={!title || saving}>
          {saving ? "Saving..." : "Save changes"}
        </button>
      </div>
    </div>
  );
}
